module.exports = new __parcel__URL__("fb-population--dataset-cover.bbcdce05.png").toString();